export const EXPERIMENT_NAMES = {
  PAYMENT_PORTAL_AB_TESTING: "Payment Portal AB Testing",
};

export const experimentConfig = {
  "Payment Portal AB Testing": {
    SiteA: 0.5,
    SiteB: 0.5,
  },
};

export const experimentSites = {
  SiteA: "SiteA",
  SiteB: "SiteB",
};
